module.exports = __webpack_public_path__ + "img/rule.144234fd.png";